import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page" className="font-body">
      <section className="pt-32 pb-16 sm:pt-40 sm:pb-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <span className="rc-eyebrow">About Rebel&amp;Co</span>
          <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold mt-5"
              style={{ letterSpacing: "-0.03em", lineHeight: "1.05" }}>
            Clarity. <span className="text-[#2d7cf6]">Confidence.</span> Private 1:1 guidance.
          </h1>
        </div>
      </section>

      <hr className="max-w-[1200px] mx-auto border-0 border-t border-[color:var(--rc-divider)]" />

      <section className="py-20 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="md:col-span-1 hidden md:block">
              <div className="h-full min-h-[220px] w-[2px] mx-auto"
                   style={{ background: "linear-gradient(180deg, rgba(45,124,246,0) 0%, #2d7cf6 50%, rgba(45,124,246,0) 100%)" }}
                   aria-hidden="true" />
            </div>
            <div className="md:col-span-7">
              <h2 className="font-display text-2xl sm:text-3xl font-semibold text-[color:var(--rc-text)] mb-5"
                  style={{ letterSpacing: "-0.02em" }}>
                Clarity to <span className="text-[#2d7cf6]">move forward.</span>
              </h2>
              <p className="text-base sm:text-lg text-[color:var(--rc-text-muted)] leading-relaxed mb-4">
                Rebel&amp;Co is a traveling 1:1 practice for gay, bi, and queer men — held in boutique spaces across the cities we visit.
              </p>
              <p className="text-base sm:text-lg text-[color:var(--rc-text-muted)] leading-relaxed">
                We talk about what you want, where you&apos;re stuck, and what moving forward looks like. Direct, encouraging, private.
              </p>
            </div>
            <div className="md:col-span-4 md:pt-2">
              <div className="pt-6 md:pt-0 border-t md:border-t-0 md:border-l border-[color:var(--rc-divider)] md:pl-8 flex md:flex-col gap-8 md:gap-7 flex-wrap">
                <div>
                  <div className="font-display text-2xl sm:text-3xl font-semibold text-[#2d7cf6]">1:1</div>
                  <div className="text-xs text-[color:var(--rc-text-muted)] uppercase tracking-[0.1em] mt-1">Private sessions</div>
                </div>
                <div>
                  <div className="font-display text-2xl sm:text-3xl font-semibold text-[#2d7cf6]">21+</div>
                  <div className="text-xs text-[color:var(--rc-text-muted)] uppercase tracking-[0.1em] mt-1">Adults only</div>
                </div>
                <div>
                  <div className="font-display text-2xl sm:text-3xl font-semibold text-[#2d7cf6]">Zero</div>
                  <div className="text-xs text-[color:var(--rc-text-muted)] uppercase tracking-[0.1em] mt-1">Judgment</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr className="max-w-[1200px] mx-auto border-0 border-t border-[color:var(--rc-divider)]" />

      <section className="py-20 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <span className="rc-eyebrow">What makes it different</span>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { t: "Traveling by design", d: "Cities on rotation. Limited availability." },
              { t: "Honest, not performed", d: "You bring you. The hour shapes around that." },
              { t: "Private above all", d: "What you explore is yours — always." },
            ].map(x => (
              <div key={x.t} className="rc-service-card">
                <div className="text-xs font-semibold uppercase tracking-[0.1em] text-[#2d7cf6] mb-3">{x.t}</div>
                <p className="text-base text-[color:var(--rc-text-muted)] leading-relaxed">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <hr className="max-w-[1200px] mx-auto border-0 border-t border-[color:var(--rc-divider)]" />

      <section className="py-20 sm:py-24 text-center">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <h2 className="font-display text-3xl sm:text-5xl font-semibold" style={{ letterSpacing: "-0.02em" }}>
            Move with confidence.
          </h2>
          <div className="mt-8">
            <Link to="/experiences" data-testid="about-explore-cta" className="rc-btn rc-btn-blue rc-btn-lg">
              Explore Experiences <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
